import React, { FC, useCallback, useState } from 'react';

import { Loader, PopUp, AlertDialog } from 'components';
import { DataStatus, RequestStatus, RequestType } from 'types/enums';
import { EcgRequestData } from '../ecg-request-data/ecg-request-data';
import { useAppDispatch, useAppSelector } from 'hooks';
import { requestsActions } from 'utils/store/slice';
import { RequestForm } from '../request-form/request-form';

export const RequestPopUp: FC = () => {
  const { analyzedRequest, status, analyzedPatientStatus } = useAppSelector((state) => state.requests);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const dispatch = useAppDispatch();
  const handleClose = useCallback(() => {
    if (analyzedRequest && analyzedRequest?.status === RequestStatus.PENDING) {
      return setIsAlertOpen(true);
    }
    dispatch(requestsActions.clearAnalyzedData());
  }, [analyzedRequest, dispatch]);
  const isLoading = status === DataStatus.LOADING || analyzedPatientStatus === DataStatus.LOADING;

  const generateRequestData = useCallback(() => {
    if (!analyzedRequest) {
      return <div>No request data</div>;
    }

    if (analyzedRequest.type === RequestType.ECG) {
      return (
        <>
          <Loader isVisible={isLoading} />
          <EcgRequestData />
        </>
      );
    }

    return <div>Unknown request type</div>;
  }, [analyzedRequest, isLoading]);

  const handleCloseAlertDialog = () => setIsAlertOpen(false);

  const handleConfirm = () => {
    setIsAlertOpen(false);
    dispatch(requestsActions.clearAnalyzedData());
  };

  return (
    <PopUp onPopUpToggle={handleClose} isOpen={Boolean(analyzedRequest)}>
      <AlertDialog
        title='Are you sure you want to close this request without response?'
        isOpen={isAlertOpen}
        onConfirm={handleConfirm}
        onCancel={handleCloseAlertDialog}
        confirmButtonText='Close request'
        cancelButtonText='Cancel'
      />
      <RequestForm />
      {generateRequestData()}
    </PopUp>
  );
};
